import {StandingsWidgetController} from "../standings-widget.controller";
import {STANDINGS_WIDGET} from "../standings-widget.consts";
import {ActionHandler} from "../../../infrastructure/handlers/action-handler";
import {StandingsWidgetState} from "../models/standings-widget.state";

export class StandingsWidgetChangeHighLightedRowsHandler extends ActionHandler {
  type = STANDINGS_WIDGET.ACTION_TYPES.changeHighlightedRows;
  controller: StandingsWidgetController;
  state: StandingsWidgetState;

  static injectables = [...ActionHandler.injectables];

  async action(params) {
    this.state.hoveredCompetitorIds = params.hoveredCompetitorIds;
  }
}
